module.exports = __webpack_public_path__ + "img/78097e6.png";